module.exports = __webpack_public_path__ + "static/media/con_hero.c34738cf.jpg";